import Obj from './obj'
import Baobab from 'baobab'
import { detect } from 'detect-browser'

export default class Component extends Obj {
    constructor (opts = {}) {
        super(opts)

        this._windowInnerWidth = window.innerWidth
        this._dataset = {}
        this._datasetBreakpoints = {}

        try {
            this._dataset = JSON.parse(JSON.stringify(this.el.dataset))
            this._datasetBreakpoints = this._dataset.breakpoints
                ? JSON.parse(this._dataset.breakpoints)
                : {}
        }
        catch (e) {
            console.warn(e)
        }

        if (this._dataset.breakpoints)
            delete this._dataset.breakpoints

        if (this.el)
            this.el.setAttribute('data-rendered', true)

        this.state = new Baobab(this.state || {})

        this._resizeDebounce = 200
        this._features = {}

        this.addFeatureTest({
            passiveeventlisteners: this._passiveeventlisteners,
            touch: () => ('ontouchstart' in window
                    && !window.navigator.userAgent.match(/X11/))
                || ('DocumentTouch' in window
                    && document instanceof window.DocumentTouch)
                || (window.navigator.maxTouchPoints || 0) > 0
        })

        delete this._passiveeventlisteners

        if (this.getBrowser('name'))
            this.addFeatureTest({ [this.getBrowser('name')]: true })

        if (this.getBrowser('os'))
            this.addFeatureTest({ [this.getBrowser('os')]: true })

        if (!this.el)
            return

        this.addFeaturesToClassName(this.el, 'touch')

        console.groupCollapsed(this.name || this.constructor.name)
        console.log(this)
        console.groupEnd()

        const getBreakpointDataset = () => Object.keys(this._datasetBreakpoints)
            .map(key => Number(key))
            .filter(int => window.innerWidth >= int && int >= 0)
            .map(int => this._datasetBreakpoints[int])
            .reduce((accObj, curObj) => Object.assign(accObj, curObj),
                Object.assign({}, this._dataset))

        const setBreakpointDataset = () => {
            if (!Object.keys(this._datasetBreakpoints).length)
                return

            const dataset = Object
                .assign({}, getBreakpointDataset() || this._dataset)

            Object.keys(dataset)
                .filter(key => this.el.dataset[key] !== String(dataset[key]))
                .forEach(key => {
                    this.el.dataset[key] = dataset[key]
                })
        }

        setBreakpointDataset()

        const emitResize = () => {
            const isWidthChange = this._windowInnerWidth !== window.innerWidth

            if (this._resizeDebounce
                    && this.el.dataset.resizing !== 'true'
                    && isWidthChange)
                this.el.dataset.resizing = true

            if (isWidthChange)
                setBreakpointDataset()

            this.emit('resize')

            if (!this._resizeDebounce)
                return

            clearTimeout(this._onResizeDebounce)

            this._onResizeDebounce = setTimeout(() => {
                this.emit('resize:debounced')

                if (this.el.dataset.resizing === 'true')
                    this.el.dataset.resizing = false

                this._windowInnerWidth = window.innerWidth
            }, this._resizeDebounce)
        }

        window.addEventListener('resize', emitResize, false)

        if (this.el.nodeType !== 1
                || !this.el.parentElement
                || this.el === document.body
                || !(['MutationObserver'] in window))
            return

        const observer = new window.MutationObserver(mutations =>
            mutations
                .forEach(mutation => {
                    if (document.body.contains(this.el))
                        return

                    observer.disconnect()

                    this.emit('destroy')
                    this.removeAllListeners()

                    window.removeEventListener('resize', emitResize, false)
                }))

        observer.observe(document.body, { childList: true, subtree: true })
    }

    addFeatureTest (obj) {
        Object.keys(obj)
            .filter(key => (typeof obj[key]).match(/boolean|function/))
            .forEach(key => {
                this._features[key] = typeof obj[key] === 'boolean'
                    ? obj[key]
                    : obj[key]()
            })

        return this
    }

    addFeaturesToClassName (el = this.el || document.documentElement, feature) {
        Object.keys(this.getFeatures())
            .filter(key => !feature
                || (feature
                    && typeof feature === 'string'
                    && key === feature))
            .forEach(key => el.classList
                .add(`${this.getFeatures()[key] ? '' : 'no-'}${key}`))

        return this
    }

    detectCSSProp (str) {
        const style = document.createElement('a').style
        style.cssText = `${str}:auto`

        const camelCase = str.toLowerCase().replace(/(-\w{1})/g,
            str => str.replace(/^-/, '').toUpperCase())

        return style[camelCase] === 'auto'
    }

    getBrowser (str) {
        const browser = detect()
            || { name: null, version: null, os: null }

        browser.os = !browser.os || typeof browser.os !== 'string'
            ? browser.os
            : browser.os
                .replace(/\s+os$/i, '')
                .replace(/([^a-z|0-9])/gi, '-')

        if (browser.name === 'edge-chromium')
            browser.name = 'chrome'

        return !str || !(str in browser)
            ? browser
            : browser[str].toLowerCase()
    }

    getFeature (str = null) {
        return typeof str === 'string'
                && str in this.getFeatures()
            ? this.getFeatures()[str]
            : null
    }

    getFeatures () {
        this._features = this._features || {}
        return this._features
    }

    generateGUID () {
        const s4 = () => (((1 + Math.random()) * 0x10000) | 0)
            .toString(16)
            .substring(1)

        return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`
    }

    isElementComputedStyleVisible (el) {
        let isVisible = true
        let node = el

        while (node !== document.body) {
            const style = window.getComputedStyle(node)

            isVisible = style.display !== 'none'
                && !style.visibility.match(/^(hidden|collapsed)$/)

            if (!isVisible)
                break

            node = node.parentElement
        }

        return isVisible
    }
}
